import {useAuth} from "../hooks/useAuth";
import {LogInState} from "../types";
import React from "react";
import {RedirectAuthenticated, RedirectToLogin, RedirectToTokenRefresh} from "./AuthStateRedirects";
import Welcome from "../pages/WelcomeScreen";

type GuardRequirement = 'logged-in' | 'guest' | 'token-expired';

export const AuthGuard = ({ require, children }: { require: GuardRequirement; children: React.ReactNode }) => {
    const { isLoggedIn } = useAuth();

    if (isLoggedIn === LogInState.AppLoading)   return <Welcome />;
    if (isLoggedIn === LogInState.TokenExpired
        && require !== 'token-expired')         return <RedirectToTokenRefresh />;
    if (isLoggedIn === LogInState.NotLoggedIn
        && require !== 'guest')                 return <RedirectToLogin />;
    if (isLoggedIn === LogInState.LoggedIn
        && require !== 'logged-in')             return <RedirectAuthenticated />;

    return <>{children}</>;
};